import createContext from '@ant-design/create-react-context';
var RowContext = createContext({});
export default RowContext;
//# sourceMappingURL=RowContext.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/grid/RowContext.js
// module id = 580
// module chunks = 0